import type {
  GetFeaturesInnerParams,
  ModalProps,
} from '@/app/components/search/components/EvolutionCard/Details/Features/getFeatures/types.ts';
import { type Feature, FeatureType } from '@/app/components/search/components/EvolutionCard/utils/facilitiesTypes.ts';
import dynamic from 'next/dynamic';

export const JourneyModalSearch = dynamic(() => import('../../../../../Modal/Modals/JourneyModalSearch'), {
  ssr: false,
});

const FlightPopover = dynamic(() => import('../../FlightPopover'), { ssr: false });

export const getTransportFeatures = ({
  isHO,
  isTH,
  dealCard,
  hasPreselectedFlightLink,
  isOverlay,
  t,
  originName,
  evolutionResultsOnlyEnabled,
}: GetFeaturesInnerParams): Feature[] => {
  if (isHO) return [];

  const transportIcon = {
    category: 'Transportation',
    name: isTH ? 'icon-train' : 'icon-airplane-takeoff',
    color: 'iconPrimary',
  } as const;
  const isOriginAvailable = dealCard?.product?.geo?.origin && dealCard?.product?.geo?.origin !== 'XXX';
  const origin = isOriginAvailable && originName ? originName : '';
  const transport = dealCard?.product?.transport;
  const hasTransportLink = hasPreselectedFlightLink && transport?.transportId && !isOverlay;

  const trainsIncludedLabel =
    isOverlay || !origin
      ? t('vacation.oss.cards.trains.return_included')
      : t('vacation.oss.cards.trains.included', { origin });

  const flightsIncludedLabel =
    isOverlay || !origin
      ? t('vacation.oss.cards.flights.return_included')
      : t('vacation.oss.card.usp.flights_from', { origin });

  const showInteractiveTransport = hasTransportLink;
  const flightTransportData =
    !isTH && showInteractiveTransport
      ? dealCard?.transport?.data?.find((item) => item.transportId === transport?.transportId)
      : undefined;
  const canOpenFlightPopover = !!flightTransportData && evolutionResultsOnlyEnabled;

  const interactionProps: Partial<Feature> = canOpenFlightPopover
    ? {
        renderPopover: ({ anchorEl }) => (
          <FlightPopover
            anchorEl={anchorEl}
            transportData={flightTransportData}
            transportId={transport!.transportId}
            ariaLabel={flightsIncludedLabel}
          />
        ),
      }
    : showInteractiveTransport && dealCard
      ? {
          Modal: ({ isOpen, onClose }: ModalProps) => (
            <JourneyModalSearch isOpen={isOpen} onClose={onClose} dealCard={dealCard} />
          ),
        }
      : {};

  return [
    {
      icon: transportIcon,
      text: isTH ? trainsIncludedLabel : flightsIncludedLabel,
      featureType: showInteractiveTransport ? FeatureType.dotted : FeatureType.normal,
      className: 'included',
      ...interactionProps,
    },
  ];
};
